import React, { useState, useEffect, useRef } from "react";
import $ from "jquery";
import jwt from "jsonwebtoken";
import { jwtSecret } from "../config";
import { apiCalling, setAuthTokens, apiCallingWithoutToken } from "../apiService";
import { authHelper, setIsAuthenticated } from "../utilis/authHelper";

const Login = (props) => {
  const [state, setState] = useState({
    username: "",
    loginpassword: "",
    otp: "",
    isDoctorLogin: false,
  });

  const [loginStep, setLoginStep] = useState(1); // 1: username, 2: password, 3: OTP

  const selfRef = useRef();

  useEffect(() => {
    selfRef.current = {
      chatmessageClickValidate,
      state
    };
  });

  useEffect(() => {
    initializeLoginComponent();
  }, []);

  const resetLoginForm = () => {
    setState({
      username: "",
      loginpassword: "",
      otp: "",
      isDoctorLogin: false,
    });
    setLoginStep(1);
    
    // Reset UI elements
    $("#username").show().val("");
    $("#loginpassword").hide().val("");
    $("#otp").hide().val("");
    $("#Loginsubmit").show();
    $("#PasswordLogin").hide();
    $("#OTPLogin").hide();
    $("#resendOTP").hide();
    $("#backButton").hide();
    $("#loginErrorMsg").text("");
    $("#loginSuccessMsg").text("");
  };

  const handleInputChange = (event) => {
    const { value, name } = event.target;
    setState(prevState => ({
      ...prevState,
      [name]: value
    }));
  };


  const isDoctorLoginFn = (event) => {
    $("#username").show();
    $("#loginpassword").hide();
    
    if (event.target.id === "doctorsLogin") {
      setState(prevState => ({ ...prevState, isDoctorLogin: true }));
      $("#doctorsLogin").addClass("logn-tab-active");
      $("#userLogin").removeClass("logn-tab-active");
    } else {
      setState(prevState => ({ ...prevState, isDoctorLogin: false }));
      $("#userLogin").addClass("logn-tab-active");
      $("#doctorsLogin").removeClass("logn-tab-active");
    }
  };

  const chatmessageClickValidate = () => {
    $(".loader").show();
    const jsonData = {
      method: "POST",
      body: JSON.stringify({
        functionName: "messageChatFree",
        chatDoctorPanelId: window.sessionStorage.getItem("chatDoctorPanelId"),
        memberId: authHelper.getUserId(),
        doctorId: window.sessionStorage.getItem("appDocId"),
        hospitalId: window.sessionStorage.getItem("appHosId"),
      }),
    };

    apiCallingWithoutToken(jsonData).then((data) => {
      if (data.success === "1") {
        window.sessionStorage.setItem("API_KEY", data.API_KEY);
        window.sessionStorage.setItem("sessionId", data.sessionId);
        window.sessionStorage.setItem("token", data.token);
        window.sessionStorage.setItem("appDocId", window.sessionStorage.getItem("appDocId"));
        window.sessionStorage.setItem("appHosId", window.sessionStorage.getItem("appHosId"));
        window.sessionStorage.setItem("chatDoctorPanelId", data.chatGroupId);
        window.location.href = "/chat/chatmessage";
      } else {
        chatmessageClickValidate();
      }
    });
  };

  const initializeLoginComponent = () => {
    $("#username").focus();

    $("#Loginsubmit").click(function () {
      $("#loginpassword").val("");
      $("#otp").val("");
      const currentState = selfRef.current.state;
      let username = currentState.username;
      let loginpassword = currentState.loginpassword;
      let loginErrorMsg = "";
      let formIsValid;
      $("#loginErrorMsg").text("");
      
      const characters = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const email = $("#username").val();
      const splitemail = email.split(/\r|\r\n|\n/);
      const phoneno = /^[0-9]*$/;
      const emailcount = splitemail.length;

      if (!username) {
        loginErrorMsg = "Please enter registered Email Id or Mobile Number";
        formIsValid = false;
      } else if (
        characters.test(splitemail[emailcount - 1]) === false &&
        $("#username").val() !== "" &&
        !phoneno.test(username)
      ) {
        loginErrorMsg = "Invalid Email Id";
        $("#username").focus();
        formIsValid = false;
      } else if (username.includes("@")) {
        setLoginStep(2);
        $("#username").hide();
        $("#loginpassword").show();
        $("#loginpassword").focus();
        $("#Loginsubmit").hide();
        $("#OTPLogin").hide();
        $("#PasswordLogin").show();
        $("#backButton").show();
      } else if (
        !username.includes("@") &&
        username.length !== 10 &&
        phoneno.test(username)
      ) {
        loginErrorMsg = "Invalid Mobile Number";
        formIsValid = false;
      } else if (!username.includes("@") && username.length === 10) {
        let mobileNumber = username;
        const token = jwt.sign(
          {
            username: mobileNumber,
            password: loginpassword,
          },
          jwtSecret()
        );
        
        const loginOTPRequest = {
          method: "POST",
          body: JSON.stringify({
            functionName: "login",
            token: token,
            siteId: window.sessionStorage.getItem("siteId"),
            otp: "",
          }),
        };
        
        $(".loader").show();
        apiCallingWithoutToken(loginOTPRequest).then((data) => {
          if (data.success === "0") {
            $("#loginErrorMsg").text("Mobile Number is not registered");
            $(".loader").hide();
            formIsValid = false;
            return false;
          } else if (data.success === "1") {
            setLoginStep(3);
            $("#username").hide();
            $("#loginpassword").hide();
            $("#otp").show();
            $("#otp").focus();
            $("#Loginsubmit").hide();
            $("#PasswordLogin").hide();
            $("#OTPLogin").show();
            $("#backButton").show();
            $("#loginSuccessMsg").text("OTP has been sent to your Mobile Number");
            setTimeout(function () {
              $("#resendOTP").show();
            }, 30000);
          } else {
            formIsValid = true;
          }
          $(".loader").hide();
        });
      } else {
        formIsValid = true;
      }
      
      if (!formIsValid) {
        $("#loginErrorMsg").text(loginErrorMsg);
        messageClear();
        return false;
      }
    });

    $("#username").keyup(function (event) {
      if (event.keyCode === 13) {
        $("#Loginsubmit").click();
        $("#loginpassword").focus();
      }
    });

    $("#loginpassword").keyup(function (event) {
      if (event.keyCode === 13) {
        $("#PasswordLogin").click();
      }
    });

    $("#forgotPswd").click(function () {
      $("#SignupWrap").hide();
      $("#signInWrapDiv").hide();
      $("#ForgotPasswordWrap").show();
      $("#emailMobno").focus();
    });

    $("#signUp").click(function () {
      $("#signInWrapDiv").hide();
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").show();
      $("#firstName").focus();
      $("#signupform").show();
      $("#loginform").hide();
      $("#signupOTP").hide();
    });

    $("#PasswordLogin").click(handlePasswordLogin);
    $("#OTPLogin").click(handleOTPLogin);
    $("#resendOTP").click(handleResendOTP);

    $(".popup-login-hide").click(function () {
      resetLoginForm();
      $(".signInWrap").hide();
    });

    $(".popup-content").click(function (event) {
      event.stopPropagation();
    });
  };

  const handlePasswordLogin = function () {
    const currentState = selfRef.current.state;
    let username = currentState.username;
    let loginpassword = currentState.loginpassword;
    let loginErrorMsg = "";
    let formIsValid;
    $("#loginErrorMsg").text("");
    
    if (!loginpassword) {
      loginErrorMsg = "Password required";
      formIsValid = false;
    } else {
      formIsValid = true;
    }
    
    if (!formIsValid) {
      $("#loginErrorMsg").text(loginErrorMsg);
      return false;
    } else {
      $("#loginErrorMsg").text("");
      const token = jwt.sign(
        {
          username: username,
          password: loginpassword,
        },
        jwtSecret()
      );
      
      let PasswordLoginRequest = {};
      if (currentState.isDoctorLogin === true) {
        PasswordLoginRequest = {
          method: "POST",
          body: JSON.stringify({
            functionName: "idaLogin",
            token: token,
            siteId: window.sessionStorage.getItem("siteId"),
            otp: "",
          }),
        };
      } else {
        PasswordLoginRequest = {
          method: "POST",
          body: JSON.stringify({
            functionName: "login",
            token: token,
            siteId: window.sessionStorage.getItem("siteId"),
            fromDevice: "Web",
            otp: "",
          }),
        };
      }
      
      setTimeout(10000);
      $(".loader").show();
      apiCallingWithoutToken(PasswordLoginRequest).then((data) => {
        if (data.success === "1") {
          $("#loginSuccessMsg").text("Logged in Successfully");
          authHelper.setLogin(data.userData[0]);
          setIsAuthenticated(true);
          setAuthTokens(data.userData[0]?.accessToken, data.userData[0]?.refreshToken);
          
          if (data.userData) {
            window.sessionStorage.setItem("userId", data.userData[0].userId);
            window.sessionStorage.setItem("emailId", data.userData[0].emailId);
            window.sessionStorage.setItem("userName", data.userData[0].userName);
            window.sessionStorage.setItem("logedSiteId", window.sessionStorage.getItem("siteId"));
            window.sessionStorage.setItem("isLogin", "true");
            $("#showMyName").text(data.userData[0].userName);
            window.sessionStorage.setItem("mobileNumber", data.userData[0].mobileNumber);

            if (data.userData[0].role === "ROLE_DOCTOR") {
              $(".doctorMenuTop").show();
              window.location.href = "/doctor/dashboard";
            }
            if (data.userData[0].role === "ROLE_USER") {
              $(".patientMenuTop").show();
            }
            if (data.userData[0].role === "ROLE_ADMIN") {
              window.location.href = "/admin/dashboard";
            }
            if (data.userData[0].role === "ROLE_GROUPHOSPITALADMIN") {
              window.location.href = "/admin/dashboard";
            }
            
            setTimeout(() => {
              $(".signInWrap").hide();
              $(".commonButton ").hide();
              $("#signInWrap").hide();
              $("#loginErrorMsg").text("");
              resetLoginForm(); // Reset form after successful login
            }, 500);
            
            handleLoginRedirect();
          }
        } else {
          $("#loginErrorMsg").text(data.errorMessage);
          $("#username").show();
          $("#loginpassword").hide();
          $("#otp").hide();
          $("#username").focus();
          $("#Loginsubmit").show();
          $("#PasswordLogin").hide();
          $("#OTPLogin").hide();
          $("#backButton").hide();
          setLoginStep(1);
          messageClear();
        }
        $(".loader").hide();
      });
    }
  };

  const handleOTPLogin = function () {
    const currentState = selfRef.current.state;
    let username = currentState.username;
    let otp = currentState.otp;
    let loginpassword = "";
    let loginErrorMsg = "";
    let formIsValid;
    $("#loginErrorMsg").text("");
    
    if (!otp) {
      loginErrorMsg = "OTP required";
      formIsValid = false;
    } else {
      formIsValid = true;
    }
    
    if (!formIsValid) {
      $("#loginErrorMsg").text(loginErrorMsg);
      return false;
    } else {
      $("#loginErrorMsg").text("");
      const token = jwt.sign(
        {
          username: username,
          password: loginpassword,
        },
        jwtSecret()
      );

      const OTPVerifiedLoginRequest = {
        method: "POST",
        body: JSON.stringify({
          functionName: "login",
          token: token,
          siteId: window.sessionStorage.getItem("siteId"),
          otp: otp,
        }),
      };
      
      $(".loader").show();
      apiCallingWithoutToken(OTPVerifiedLoginRequest).then((data) => {
        if (data.success === "1") {
          $("#loginSuccessMsg").text("Logged in Successfully");
          if (data.userData) {
            authHelper.setLogin(data.userData[0]);
            setIsAuthenticated(true);
            setAuthTokens(data.userData[0]?.accessToken, data.userData[0]?.refreshToken);
            window.sessionStorage.setItem("userName", data.userData[0].userName);
            window.sessionStorage.setItem("isLogin", "true");
            window.sessionStorage.setItem("mobileNumber", data.userData[0].mobileNumber);
            
            if (data.userData[0].role === "ROLE_DOCTOR") {
              $(".doctorMenuTop").show();
              window.location.href = "/doctor/dashboard";
            }
            if (data.userData[0].role === "ROLE_USER") {
              $(".patientMenuTop").show();
            }

            setTimeout(() => {
              $(".signInWrap").hide();
              $(".commonButton ").hide();
              $("#signInWrap").hide();
              $("#loginErrorMsg").text("");
              resetLoginForm(); // Reset form after successful login
            }, 500);
            
            handleLoginRedirect();
          }
        } else {
          authHelper.logout();
          $("#loginErrorMsg").text(data.successMessage);
          $("#loginSuccessMsg").hide();
          setTimeout(function () {
            $("#resendOTP").show();
          }, 30000);
          messageClear();
        }
        $(".loader").hide();
      });
    }
  };

  const handleResendOTP = function () {
    let formIsValid;
    $("#loginErrorMsg").text("");
    const currentState = selfRef.current.state;
    let mobileNumber = currentState.username;
    let loginpassword = "";
    
    const token = jwt.sign(
      {
        username: mobileNumber,
        password: loginpassword,
      },
      jwtSecret()
    );
    
    const ResendOTPRequest = {
      method: "POST",
      body: JSON.stringify({
        functionName: "login",
        token: token,
        siteId: window.sessionStorage.getItem("siteId"),
        otp: "",
      }),
    };
    
    $(".loader").show();
    apiCallingWithoutToken(ResendOTPRequest).then((data) => {
      if (data.success === "0") {
        $("#loginErrorMsg").text("Mobile Number is not registered");
        formIsValid = false;
        return false;
      } else if (data.success === "1") {
        $("#username").hide();
        $("#loginpassword").hide();
        $("#otp").show();
        $("#otp").focus();
        $("#Loginsubmit").hide();
        $("#PasswordLogin").hide();
        $("#OTPLogin").show();
        $("#resendOTP").hide();
        $("#loginSuccessMsg").show();
      } else {
        formIsValid = true;
      }
      $(".loader").hide();
    });
  };

  const handleLoginRedirect = () => {
    if (window.sessionStorage.getItem("loginValidate") === "book") {
      window.sessionStorage.setItem("loginValidate", "");
      if (window.sessionStorage.getItem("siteId") == 1) {
        if (window.sessionStorage.getItem("IDASlug"))
          window.location.href = "/Doctor-" + window.sessionStorage.getItem("IDASlug");
      } else {
        window.location.href = "/patient/bookappointment";
      }
    }
    if (window.sessionStorage.getItem("loginValidate") === "TextChatPay") {
      window.sessionStorage.setItem("loginValidate", "");
      window.location.href = "/patient/textchatpayment";
    }
    if (window.sessionStorage.getItem("loginValidate") === "TextChatFree") {
      window.sessionStorage.setItem("loginValidate", "");
      selfRef.current.chatmessageClickValidate();
    }
  };

  const messageClear = () => {
    setTimeout(() => {
      $("#loginErrorMsg").text("");
    }, 5000);
  };

  const siteName = window.location.host;

  return (
    <div className="popup-overlay signInPopup">
      <div className="popup-content">
        <div className="modal-popup">
          <div className="close-popup popup-login-hide" title="close" onClick={resetLoginForm}>
            &times;
          </div>
          <div className="signInHead">
            <h2>LOGIN</h2>
            <p id="loginErrorMsg" style={{ color: "red", fontSize: "12px" }}></p>
            <p id="loginSuccessMsg" style={{ color: "green", fontSize: "12px" }}></p>
          </div>
          {window.sessionStorage.getItem("isIDALogin") === "true" && (
            <div className="logn-tab-main">
              {/* Login tabs can be added here if needed */}
            </div>
          )}
          <div className="signInBody">
            {/* Back Button - Only show when not on username step */}
       
            
            <input
              type="text"
              id="username"
              name="username"
              className="input-design my-2"
              placeholder="Email ID Or Mobile Number"
              value={state.username}
              onChange={handleInputChange}
            />
            <div id="subLiginDiv">
              <input
                type="password"
                id="loginpassword"
                name="loginpassword"
                className="input-design my-2"
                placeholder="Password"
                style={{ display: "none" }}
                value={state.loginpassword}
                onChange={handleInputChange}
              />
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  className="input-design my-2"
                  placeholder="OTP"
                  style={{ display: "none" }}
                  value={state.otp}
                  onChange={handleInputChange}
                />
                <button id="resendOTP" className="otpButton" style={{ display: "none" }}>
                  Resend OTP
                </button>
              </div>
            </div>
            <div className="signInForgot">
              <a id="forgotPswd">Forgot?</a>
            </div>
            <div className="signInButton">
              <button className="formButtonBg" id="Loginsubmit">
                Submit
              </button>
            </div>
            <div className="signInButton">
              <button
                className="formButtonBg"
                style={{ display: "none" }}
                type="submit"
                id="PasswordLogin"
              >
                Sign In
              </button>
            </div>
            <div className="signInButton">
              <button
                className="formButtonBg"
                style={{ display: "none" }}
                type="submit"
                id="OTPLogin"
              >
                Sign In
              </button>
            </div>
            {siteName.includes("idasparsh") ? "" : (
              <div className="signUp">
                <h3>
                  Don't have an account? <a id="signUp">Register here</a>
                </h3>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;